import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IdleTimerService } from './idle-timer.service';
import { ssoConfig } from '../sso.config';
import { Router } from '@angular/router';
import { BehaviorSubject, throwError } from 'rxjs';
import { CommonService } from 'src/app/core/services/Common/common.service';
import { environment } from 'src/environments/environment';

// AFTER GETTING ACCESS TOKEN 
@Injectable({ providedIn: 'root' })
export class AuthService {
  private refreshUrl = '/auth/refreshToken';
  private logoutUrl = '/auth/logout';

  private timerInterval: any;
  public tokenExpiresInSecond: BehaviorSubject<any> = new BehaviorSubject(null);
  public isRefreskTokenApiCalled = false;

  constructor(private router: Router,private commonService: CommonService,private idleTimerService: IdleTimerService) {}

  // startTimerOnLogin() {
  //   const expiryTime = Date.now() + (ssoConfig.tokenExpiresInMin-1) * 60 * 1000;

  //   this.idleTimer.startWatching(
  //     expiryTime,
  //     () => this.refreshToken(),
  //     () => this.logout()
  //   );
  // }

  // refreshToken() {
  //   const accessToken = localStorage.getItem('token');
  //   if (!accessToken) return this.logout();

  //   this.http.post<any>(this.refreshUrl, {},{
  //     headers: {
  //       Authorization: accessToken
  //     }
  //   }).subscribe({
  //     next: (res) => {
  //       const expiryTime = Date.now() + (ssoConfig.tokenExpiresInMin-1) * 60 * 1000;
  //       localStorage.setItem('token', res.accessToken);

  //       this.idleTimer.startWatching(
  //         expiryTime,
  //         () => this.refreshToken(),
  //         () => this.logout()
  //       );
  //     },
  //     error: () => this.logout()
  //   });
  // }

  // logout() {
  //   this.idleTimer.stopWatching();
  //   localStorage.clear();
  //   this.router.navigate(['/home']);
  // }

  public logOut(isAllLogout: boolean = true){
    this.clearTimer();
    this.idleTimerService.stopWatching();
    localStorage.clear();
    if(isAllLogout){
      const redirectUrl = `${environment.ssoURL}?logout=true`
      window.location.href = redirectUrl;
    }
    else{
      this.router.navigate(['/home']);
    }
  }

  public initTimer() {
    try {
      this.clearTimer();
      const accessToken = localStorage.getItem('token');
      if (typeof accessToken !== 'undefined' && accessToken) {
        const accessTokenSplit = accessToken.split('.');
        const accessPayloadPart = accessTokenSplit[1];
        const decodedPayload = JSON.parse(window.atob(accessPayloadPart));
        const tokenExpiryTimestamp = decodedPayload.exp;
        const timeRemainingInSeconds = Math.round((new Date(tokenExpiryTimestamp)).getTime() - ((new Date()).getTime() / 1000));
        this.tokenExpiresInSecond.next(timeRemainingInSeconds);
        this.timerInterval = setInterval(() => {
          this.tokenExpiresInSecond.next(this.tokenExpiresInSecond.getValue() - 1);
        }, 1000);
      }
    } catch (e) {
      console.error('initTimer ERROR: ', e);
    }
  }

  public clearTimer() {
    clearInterval(this.timerInterval);
  }

  public renewAccessToken() {
    // if (this.tokenRefreshedCount <= 6) {
      this.isRefreskTokenApiCalled = true;
      this.commonService.postAPICall({url: this.refreshUrl})
        .subscribe({
          next: (response: any) => {
            // console.log('REFRESH');
            // if already logged in then only accept the new token
            if(localStorage.getItem('token') && localStorage.getItem('isLoggedIn')){
              localStorage.setItem('token', response?.data?.newAccessToken);
              this.initTimer();
            }
            this.isRefreskTokenApiCalled = false;
          },
          error: (error) => {
            throwError(() => error);
            this.isRefreskTokenApiCalled = false;
          }
        });
    // }
  }
}